<template>
  <div class="flex justify-between">
    <!-- <a @click="setFrom" class="button-primary button-is-small block w-half" :class="{ disabled: loading }">
      <span v-if="loading">
        <svg class="animate-spin h-5 w-5 text-gray-300 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </span>
      <span v-else>
        ここから出発
      </span>
    </a>
    <a @click="setTo" class="button-primary button-is-small block w-half" :class="{ disabled: loading }">
      <span v-if="loading">
        <svg class="animate-spin h-5 w-5 text-gray-300 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </span>
      <span v-else>
        ここへ行く
      </span>
    </a> -->
    <a @click="searchRtWeb" class="button-primary button-is-small block w-full" :class="{ disabled: loading }">
      <span v-if="loading">
        <svg class="animate-spin h-5 w-5 text-gray-300 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </span>
      <span v-else>
        この場所への行き方を調べる
      </span>
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Constants from '../../../constants'
import { event } from 'vue-gtag'

export default {
  data () {
    return {
      loading: false
    }
  },
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      lang: 'user/getLang'
    }),
    defaultStationLocation: function () {
      return Constants.DEFAULT_STATION_LOCATION
    }
  },
  methods: {
    searchRoute: function () {
      if (this.lang === undefined || this.lang == "ja") {
        //探索結果(JR東日本アプリのディープリンク)
        this.openJreApp()
      } else {
        //多言語はmixwayに投げる
        this.openMixway()
      }
    },
    openJreApp: function () {
      const userAgent = navigator.userAgent.toLowerCase()

      if (userAgent.search(/iphone|ipad|ipod/) > -1 || userAgent.search(/android/) > -1) {
        const path = "/search?"

        // スマートフォンならアプリかストアを開く
        const params = {
          topoi: this.place.shortName !== undefined ? this.place.shortName : this.place.name,
          tolatitude: this.place.location.latitude,
          tolongitude: this.place.location.longitude
        }
        document.location = Constants.JREAST_APP_SCHEMA + path + this.toGetOptions(params)
      } else {
        // その他・不明・PCなどの場合はサイトを開く
        window.open(Constants.JREAST_PC_SITE)
      }
    },
    openMixway: function () {
      this.loading = true
      this.$store.dispatch('geolocation/fetchLocation')
        .then(() => {
          // 現在地
          const fromLocation = this.$store.getters['geolocation/getLocation']
          this.openUrl(fromLocation, this.$t('tour_present_location'))
        })
        .catch(() => {
          // 取得できない場合は出町柳駅
          this.openUrl(this.defaultStationLocation, this.$t('tour_demachiyanagi_station'))
        })
        .finally(() => this.loading = false)
    },
    openUrl: function (fromLocation, fromName) {
      const lang = this.lang == "zh-TW" ? "zh_tw" : "en"
      const path = "/" + lang + "/courses?"

      const from = Object.values(fromLocation).join(",")
      const to = Object.values(this.place.location).join(",")

      const params = {
        fromName: fromName,
        toName: this.place.shortName !== undefined ? this.place.shortName : this.place.name,
        viaList: [from, to].join(":")
      }

      const url = Constants.MIXWAY_URL + path + this.toGetOptions(params)

      window.open(url, '_blank')
    },
    toGetOptions: function (params) {
      return Object.entries(params).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&')
    },
    setFrom: function () {
      this.$store.dispatch('map/setSearchFrom', this.place)
      this.$store.dispatch('drawer/close')

    },
    setTo: function () {
      this.$store.dispatch('map/setSearchTo', this.place)
      this.$store.dispatch('drawer/close')
    },
    searchRtWeb: function () {
      const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
      var url = Constants.REAL_TIME_SEARCH_WEB_LIST[env_key] + "?utm_source=chofu&utm_medium=referral&utm_campaign=chofu"
      if (this.place.location !== undefined) {
        url += "&topoi=" +encodeURIComponent(this.place.shortName !== undefined ? this.place.shortName : this.place.name)
        if (this.place.stationCode !== undefined) {
          url += "&tocode=" + this.place.stationCode
        } else {
          url += "&tolatitude=" + this.place.location.latitude + "&tolongitude=" + this.place.location.longitude
        }
      }
      if (this.token !== null) {
        url += "&token=" + this.token
      }
      event('ルートを検索',{from:"現在地",to:this.place.name,route:"現在地:"+this.place.name})          
      window.open(url)
      
    },
  }
}
</script>
